<section class="sbnb-onboarding">
  <sbnb-signup-header [hideActions]="true"></sbnb-signup-header>

  <article class="main">
    <header>
      <h1>Welcome home!</h1>
    </header>
    <section class="content" *ngIf="!isAirbnbSignup">
      <p class="subheader">
        We are excited to start helping you save time and deliver a better guest experience.
        <br />
        <br />
        To make the best use of your trial period, we recommend you start by connecting your
        {{ platformUi | titlecase }} account.
      </p>
      <button [disabled]="actioning" mat-flat-button class="next-step" (click)="login()">
        <mat-spinner *ngIf="actioning" class="button__spinner" [diameter]="30"></mat-spinner>
        Connect with {{ platformUi | titlecase }}
      </button>

      <a mat-button class="do-it-later" (click)="doItLater()">I'll do it later</a>
    </section>

    <section class="content" *ngIf="isAirbnbSignup">
      <p class="subheader">
        We are excited for you and your guests to start benefiting from our state-of-the-art technology and time-saving
        features.
      </p>
      <button [disabled]="actioning" mat-flat-button class="next-step" (click)="login()">
        <mat-spinner *ngIf="actioning" class="button__spinner" [diameter]="30"></mat-spinner>
        Get started with the basics
      </button>
    </section>
  </article>

  <aside>
    <img src="/assets/images/signup/done.svg" />
  </aside>
</section>

<!-- Capterra tracking Pixel -->
<img src="https://ct.capterra.com/capterra_tracker.gif?vid=2132563&vkey=1e99854893385b6328e80d70b1cd00e3" />
